import React from 'react';
import PropTypes from 'prop-types';
import { Spacer, Visible } from '@tfecom-thermofisher/react-komodo-design';

import { Title } from 'src/core/components';

import messages from './messages';
import './SectionTitle.style.scss';

const SectionTitle = ({ title, allFieldsRequired }) => (
  <>
    <Title
      className="dna-section-title"
      font="bold"
      size="4"
      message={title}
    >
      <Visible when={allFieldsRequired}>
        <Spacer right={40} />
        <div className="dna-section-title__require-icon">*</div>
        <Spacer right={2} />
        <Title
          className="dna-section-title__fields-required"
          font="normal"
          size="5"
          message={messages.fieldsRequired}
        />
      </Visible>
    </Title>
  </>
);

SectionTitle.propTypes = {
  title: PropTypes.object,
  allFieldsRequired: PropTypes.bool,
};

export default SectionTitle;
